(() => {
  if (!document.body.classList.contains('template-product')) return;

  const fallbackStyle = document.createElement('style');
  fallbackStyle.textContent = `
    .rx-product-media-fallback{width:100%;height:100%;display:block;object-fit:contain;background:#050505}
    .ap26-editorial-video__inner.is-empty>.rx-product-media-fallback{min-height:inherit}
  `;
  document.head.appendChild(fallbackStyle);

  function getCurrentProductImages() {
    const selectors = [
      '[data-reluxe-reference-hero] .rf-product-hero__stage img',
      '.rx-gallery .rx-slide > img'
    ];
    const seen = new Set();
    const images = [];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((img) => {
        const src = img.currentSrc || img.src;
        if (!src || seen.has(src)) return;
        seen.add(src);
        images.push(img);
      });
    });

    return images;
  }

  function applyProductMediaFallbacks(scope = document) {
    const images = getCurrentProductImages();
    if (!images.length) return;

    const placeholders = scope.querySelectorAll(
      '.ap26-media-placeholder,.ap26-editorial-video__placeholder,.lux-flex-media--empty'
    );

    placeholders.forEach((placeholder, index) => {
      const source = images[index % images.length] || images[0];
      const clone = source.cloneNode(true);
      clone.className = 'rx-product-media-fallback';
      clone.loading = 'lazy';
      clone.removeAttribute('fetchpriority');
      clone.removeAttribute('hidden');
      clone.setAttribute('data-rx-product-media-fallback', '');
      placeholder.replaceWith(clone);
    });
  }

  const runFallbacks = () => applyProductMediaFallbacks(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runFallbacks, { once: true });
  } else {
    runFallbacks();
  }

  document.addEventListener('shopify:section:load', (event) => {
    requestAnimationFrame(() => applyProductMediaFallbacks(event.target || document));
  });
})();

(() => {
  if (!document.body.classList.contains('template-product')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const style = document.createElement('style');
  style.textContent = `
    .rx-reveal{opacity:0;transform:translate3d(0,30px,0);transition:opacity 1.25s cubic-bezier(.22,1,.36,1),transform 1.4s cubic-bezier(.22,1,.36,1);transition-delay:var(--rx-reveal-delay,0ms);will-change:opacity,transform}
    .rx-reveal.rx-reveal--media{transform:translate3d(0,38px,0) scale(.982);transition:opacity 1.4s cubic-bezier(.22,1,.36,1),transform 1.65s cubic-bezier(.22,1,.36,1)}
    .rx-reveal.is-visible{opacity:1;transform:translate3d(0,0,0) scale(1)}
    @media(max-width:899px){.rx-reveal{transform:translate3d(0,20px,0)}.rx-reveal.rx-reveal--media{transform:translate3d(0,25px,0) scale(.99)}}
    @media(prefers-reduced-motion:reduce){.rx-reveal{opacity:1!important;transform:none!important;transition:none!important}}
  `;
  document.head.appendChild(style);

  const selectors = [
    '.rx-heading','.rx-purchase','.rx-source-intro','.rx-gallery',
    '.code-detail__copy','.code-detail__media','.code-editorial h2','.code-editorial figure',
    '.code-specs h2','.code-specs h3','.code-specs p','.code-specs dl','.code-spec-image',
    '.ap26-detail__copy','.ap26-detail__media','.rf-editorial h2','.rf-editorial p',
    '.rf-rail figure','.rf-finishing > *','.rf-spec-heading','.rf-watch-specs > *',
    '.rf-calibre > *','.rf-related > *',
    '.product__title','.product__text','.product__description','.product__media','.product-media-container',
    '.product__info-container > *','.product-gallery > *','product-info > *','product-gallery > *'
  ];

  const mediaSelector = '.rx-gallery,.code-detail__media,.code-editorial figure,.code-spec-image,.ap26-detail__media,.rf-rail figure,.rf-finishing>img,.rf-watch-specs__image,reference-calibre,.product__media,.product-media-container,.product-gallery>*,product-gallery>*';
  const seen = new Set();
  const items = [];

  document.querySelectorAll(selectors.join(',')).forEach((el) => {
    if (seen.has(el)) return;
    seen.add(el);
    el.classList.add('rx-reveal');
    if (el.matches(mediaSelector)) el.classList.add('rx-reveal--media');
    items.push(el);
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  items.forEach((el) => {
    const rect = el.getBoundingClientRect();
    const aboveFold = rect.top < window.innerHeight * .92;
    const siblings = el.parentElement ? Array.from(el.parentElement.children).filter((child) => child.classList?.contains('rx-reveal')) : [];
    const siblingIndex = Math.max(0, siblings.indexOf(el));
    el.style.setProperty('--rx-reveal-delay', `${Math.min(siblingIndex * 95, 285)}ms`);
    if (aboveFold) {
      requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-visible')));
    } else {
      observer.observe(el);
    }
  });
})();
